import { useState, useCallback } from 'react';
import WhatsAppCloudApiService from '../services/WhatsAppCloudApiService';

export default function useCloudApi(agentId) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(async () => {
    if (!agentId) return null;
    setLoading(true);
    setError(null);
    try {
      const resp = await WhatsAppCloudApiService.getStatus(agentId);
      setStatus(resp.data);
      return resp.data;
    } catch (err) {
      console.error('[CLOUD-API] fetchStatus falhou:', err);
      setError(err.response?.data?.error || 'Erro ao buscar status.');
      return null;
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  const connect = useCallback(async (data) => {
    if (!agentId) return null;
    setLoading(true);
    setError(null);
    try {
      const resp = await WhatsAppCloudApiService.connect(agentId, data);
      await fetchStatus();
      return resp.data;
    } catch (err) {
      console.error('[CLOUD-API] connect falhou:', err);
      const msg = err.response?.data?.error || 'Erro ao conectar.';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, [agentId, fetchStatus]);

  const connectManual = useCallback(async (data) => {
    if (!agentId) return null;
    setLoading(true);
    setError(null);
    try {
      const resp = await WhatsAppCloudApiService.connectManual(agentId, data);
      await fetchStatus();
      return resp.data;
    } catch (err) {
      console.error('[CLOUD-API] connectManual falhou:', err);
      const msg = err.response?.data?.error || 'Erro ao conectar manualmente.';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, [agentId, fetchStatus]);

  const disconnect = useCallback(async () => {
    if (!agentId) return;
    setLoading(true);
    setError(null);
    try {
      await WhatsAppCloudApiService.disconnect(agentId);
      setStatus({ connected: false });
    } catch (err) {
      console.error('[CLOUD-API] disconnect falhou:', err);
      setError(err.response?.data?.error || 'Erro ao desconectar.');
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  return {
    status,
    loading,
    error,
    isConnected: status?.connected === true,
    fetchStatus,
    connect,
    connectManual,
    disconnect,
    setError,
  };
}
